export default __webpack_public_path__ + "static/media/google-play.16b47a9c.png";